import {Component} from '@angular/core';
import {Store} from '@ngxs/store';
import {AuthState} from '../../../../../state/auth/auth.state';
import {AuthActions} from '../../../../../state/auth/auth.actions';
import {User} from '../../../../../models/api/user.model';
import {ViewSelectSnapshot} from '@ngxs-labs/select-snapshot';
import {UserActions} from '../../../../../state/user/user.actions';

@Component({
    selector: 'app-navbar-user-menu',
    templateUrl: './navbar-user-menu.component.html',
    styleUrls: ['./navbar-user-menu.component.less'],
    standalone: false,
})
export class NavbarUserMenuComponent {
    @ViewSelectSnapshot(AuthState.currentUser) user: User;

    constructor(private store: Store) {}

    logout() {
        this.store.dispatch(new AuthActions.LogoutRequest());
    }

    changePassword() {
        this.store.dispatch(new AuthActions.PasswordChange());
    }

    emailNotifications() {
        this.store.dispatch(new UserActions.EmailNotificationsModal(this.user));
    }
}
